import { get, GetReturnType, post, put, remove } from "src/api/fetch";
import { getSchemaFromUrl } from "src/router/routes";
import { Type_Category } from "src/types/category";

export const getCategories = (): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/categories`);
};

export const createCategory = (
    body: Omit<Type_Category, "id">,
): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }
    return post(body, `${VITE_API_URL}/${getSchemaFromUrl()}/categories`);
};

export const updateCategory = (
    categoryId: number,
    body: Partial<Type_Category>,
): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }
    return put(
        body,
        `${VITE_API_URL}/${getSchemaFromUrl()}/categories/${categoryId}`,
    );
};

export const deleteCategory = (id: number): GetReturnType => {
    return remove(`${VITE_API_URL}/${getSchemaFromUrl()}/categories/${id}`);
};
